// src/router/router.tsx
import React from 'react';
import { Navigate, Routes, Route, useLocation } from 'react-router-dom';
import Home from '../pages/Home/Home';
import SignupForm from '../pages/SignupForm/SignupForm';
import AddAdPage from '../pages/Ads/AddAds';
import AdDetailsPage from '../pages/AdDetails/AdDetails';
import MyAdsPage from '../pages/MyAds/MyAds';
import MyBookingsPage from '../pages/MyBookings/MyBookings';
import ReservationManagementPage from '../pages/MyReservations/ReservationManagement';
import ProfileInfoPage from '../pages/ProfileInfo/ProfileInfo';
import DashboardPage from '../pages/Dashboard/Dashboard';
import MessagesPage from '../pages/Messages/Messages';
import OwnerAdsPage from '../pages/OwnerAds/OwnerAds';
import ForgotPasswordPage from '../pages/ForgotPassword/ForgotPassword';
import ResetPasswordPage from '../pages/ResetPassword/ResetPassword';
import RateStayPage from '../pages/RateStay/RateStay';

const ScrollToTop: React.FC = () => {
    const { pathname } = useLocation();

    React.useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    }, [pathname]);

    return null;
};

const AppRouter: React.FC = () => {
    return (
        <>
            <ScrollToTop />
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/login" element={<Navigate to="/register" replace />} />
                <Route path="/register" element={<SignupForm />} />
                <Route path="/forgot-password" element={<ForgotPasswordPage />} />
                <Route path="/reset-password" element={<ResetPasswordPage />} />
                <Route path="/rate-stay/:token" element={<RateStayPage />} />
                <Route path="/change-password" element={<ResetPasswordPage />} />
                <Route path="/profile/:id" element={<SignupForm />} />
                <Route path="/profile-info" element={<ProfileInfoPage />} />
                <Route path="/add-ads/:id?" element={<AddAdPage />} />
                <Route path="/ads/:id" element={<AdDetailsPage />} />
                <Route path="/my-ads" element={<MyAdsPage />} />
                <Route path="/my-bookings" element={<MyBookingsPage />} />
                <Route path="/reservation-management" element={<ReservationManagementPage />} />
                <Route path="/messages" element={<MessagesPage />} />
                <Route path="/dashboard" element={<DashboardPage />} />
                <Route path="/owner/:ownerId/ads" element={<OwnerAdsPage />} />
            </Routes>
        </>
    );
};

export default AppRouter;
